import { combineReducers } from 'redux';
import { reducer as completion } from './completion';

export const flow = combineReducers({
  completion,
});
